import React, { useState, useEffect, useRef } from "react";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import { Button } from "antd";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "jspdf-autotable";
import NavbarAdmin from "../../Components/NavbarAdmin/NavbarAdmin";
import Table from "../../Components/TableTemplate/Table";
import {
  formatAmount,
  getRestoLogin,
  getRole,
  numberWithCommas,
  refreshPage,
  toastStyle,
} from "../../Helpers/Utils/Common";
import { getPaymentReport } from "../../Helpers/apiCalls/paymentAPI";
import { useNavigate } from "react-router-dom";
import { printBase64 } from "../../Helpers/apiCalls/paymentAPI";
import { DownloadTableExcel } from "react-export-table-to-excel";
import imageCompression from "compressorjs";
import toast from "react-hot-toast";
import moment from "moment";

export default function PaymentReport() {
  const role = getRole();
  const navigate = useNavigate();
  const cashRef = useRef(null);
  const creditRef = useRef(null);
  const dateToday = moment().format("YYYY-MM-DD");
  const [inactive, setInactive] = useState(true);
  const [cashTableData, setCashTableData] = useState([]);
  const [creditTableData, setCreditTableData] = useState({});
  const [creditType, setCreditType] = useState("card");
  const [showLoader, setShowLoader] = useState(false);
  const [isHidden, setisHidden] = useState(true);

  const [totalSummary, setTotalSummary] = useState({
    total_transaction: 0,
    total_sales: 0,
  });
  const [filter, setFilter] = useState({
    date_from: dateToday,
    date_to: dateToday,
    payment_type: "cash",
  });

  // Handle for export to pdf
  const handleExportPDF = (e) => {
    if (filter.payment_type === "cash") {
      const pdf = new jsPDF();
      const content = cashRef.current;
      html2canvas(content).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        // const imgWidth = 200;
        const imgWidth = 100;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        const x = (pdf.internal.pageSize.width - imgWidth) / 2;
        pdf.addImage(imgData, "PNG", x, 10, imgWidth, imgHeight);
        pdf.save("Payment Report.pdf");
      });
    } else {
      const pdf = new jsPDF();
      const content = creditRef.current;
      html2canvas(content).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        // const imgWidth = 200;
        const imgWidth = 100;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        const x = (pdf.internal.pageSize.width - imgWidth) / 2;
        pdf.addImage(imgData, "PNG", x, 10, imgWidth, imgHeight);
        pdf.save("Payment Report.pdf");
      });
    }
  };

  const handleFilter = (e) => {
    const { name, value } = e.target;
    var filtercopy = { ...filter };
    filtercopy[name] = value;
    setFilter(filtercopy);
  };

  const [allowPrint, setAllowPrint] = useState(false);
  const handleOpenPrint = () => {
    setAllowPrint(true);
  };

  const handlePrint = () => {
    if (filter.payment_type === "cash" && cashRef.current) {
      const element = cashRef.current;

      html2canvas(element, { scale: 1 }).then((canvas) => {
        canvas.toBlob((blob) => {
          new imageCompression(blob, {
            quality: 0.06,
            maxWidth: 2024,
            // maxHeight: 1024,
            success(compressedResult) {
              const reader = new FileReader();
              reader.readAsDataURL(compressedResult);
              reader.onloadend = () => {
                const compressedBase64 = reader.result;
                // Pass the compressed Base64 image to the printBase64Data function
                printBase64Data(compressedBase64);
                toast.success("Processing...", {
                  style: toastStyle(),
                });
              };
            },
          });
        }, "image/pngs");
      });
    } else if (filter.payment_type === "credit" && creditRef.current) {
      const element = creditRef.current;
      // element.style.width = "36%";
      // element.style.height = "100%"

      html2canvas(element, { scale: 1 }).then((canvas) => {
        canvas.toBlob((blob) => {
          new imageCompression(blob, {
            quality: 0.6,
            maxWidth: 2024,
            // maxHeight: 1024,
            success(compressedResult) {
              const reader = new FileReader();
              reader.readAsDataURL(compressedResult);
              reader.onloadend = () => {
                const compressedBase64 = reader.result;
                // Pass the compressed Base64 image to the printBase64Data function
                printBase64Data(compressedBase64);
                toast.success("Processing...", {
                  style: toastStyle(),
                });
              };
            },
          });
        }, "image/pngs");
      });
    }
  };

  async function printBase64Data(image) {
    const response = await printBase64(
      window.printer_name,
      image,
      "0",
      getRestoLogin(),
      "Payment"
    );
    if (response.data) {
      setAllowPrint(false);
      setAllowPrint(false);
      refreshPage();
    } else {
      setAllowPrint(false);
    }
  }

  /** EXPORT */
  function handleToCSV() {
    return (
      <DownloadTableExcel
        filename="Payment Report"
        sheet="users"
        currentTableRef={
          filter.payment_type === "cash" ? cashRef.current : creditRef.current
        }
      >
        <button className=" category-new-export-btn w-100">Export CSV</button>
      </DownloadTableExcel>
    );
  }

  //useeffects
  useEffect(() => {
    if (allowPrint === true) {
      handlePrint();
    } else {
    }
  }, [allowPrint]);

  async function fetchTableData() {
    setCashTableData([]);
    setShowLoader(true);
    const response = await getPaymentReport(filter, getRestoLogin());
    setTotalSummary({
      total_sales: 0,
      total_transaction: 0,
    });
    if (response.data) {
      if (filter.payment_type === "cash") {
        const res = response.data.data?.cash?.map((row) => {
          return {
            amount: numberWithCommas(row.amount),
            si_no: row.si_no,
          };
        });
        setTotalSummary({
          total_sales: response.data.data?.cash_subtotal,
          total_transaction: res.length,
        });
        setCashTableData(res);
      } else if (filter.payment_type === "credit") {
        setCreditTableData(response.data.data);
        setTotalSummary({
          total_sales: response.data.data?.card_subtotal,
          total_transaction: response.data.data?.card?.length,
        });
      }
    }
    setShowLoader(false);
  }

  useEffect(() => {
    fetchTableData();
  }, [filter]);

  const marginTop = "-800px";
  const marginRight = "60px";
  const marginBottom = "-1000px";
  const marginLeft = "45px";
  const getPageMargins = () => {
    return `@page { margin: ${marginTop} ${marginRight} ${marginBottom} ${marginLeft} !important;}`;
  };

  return (
    <div>
      {/* {role === "1" && ( */}
      <NavbarAdmin
        onCollapse={(inactive) => {
          setInactive(inactive);
        }}
        active={"Reports"}
        page={"Reports"}
      />
      {/* )} */}
      <div
        className={`container bold-font ${
          getRole() === "" ? "cashier" : inactive ? "inactive" : "active"
        }`}
      >
        <Row>
          <Col xs={12} lg={7}>
            <h1 className="page-title-menu">DAILY PAYMENT SUMMARY REPORT</h1>
          </Col>
          <Col xs={12} lg={5} className="">
            <Row className="d-flex justify-content-space between">
              <Col xs={3}>
                <button
                  className="category-new-export-btn w-100"
                  value="print"
                  onClick={handleOpenPrint}
                >
                  Print
                </button>
              </Col>
              <Col xs={4}>
                <button
                  className="category-new-export-btn w-100"
                  value="pdf-1"
                  onClick={handleExportPDF}
                >
                  Export PDF
                </button>
              </Col>
              {role === "1" && <Col xs={4}>{handleToCSV()}</Col>}
              {/* {role === "2" && (
                <Col xs={4}>
                  <button
                    className="category-new-export-btn"
                    value="pdf-1"
                    onClick={() => navigate(-1)}
                  >
                    Back
                  </button>
                </Col>
              )} */}
            </Row>
          </Col>
        </Row>
        <Row>
          {/* <Tabs
            defaultActiveKey="daily"
            transition={false}
            onSelect={handleTabSelect}
          >
            <Tab eventKey="daily" title="daily"> */}
          <div className="table-content mt-4">
            <Row className="pt-3 w-60">
              <Col className="cat-container">
                <label className="select-label">Filter by Type:</label>
                <select
                  id="payment_type"
                  name="payment_type"
                  className="responsive-select"
                  value={filter.payment_type}
                  onChange={handleFilter}
                >
                  <option value="" hidden selected>
                    Select Type
                  </option>
                  <option value="cash">Cash</option>
                  <option value="credit">Credit</option>
                </select>
              </Col>
              <Col className="cat-container">
                <label>Date:</label>
                <input
                  type="date"
                  name="date_from"
                  id="date_from"
                  className="responsive-date-input ms-2"
                  defaultValue={filter.date_from}
                  // onChange={handleFilter}
                  onChange={(e) => {
                    setFilter((prev) => ({
                      ...prev,
                      date_from: e.target.value,
                      date_to: e.target.value,
                    }));
                  }}
                ></input>
              </Col>
            </Row>
            <Row>
              <Row className="d-flex justify-content-between mt-3">
                <Col xs={6}>
                  <h5>
                    Total Transactions : &nbsp;
                    {totalSummary.total_transaction}
                  </h5>
                </Col>
                <Col xs={6} className="text-end">
                  <h5>
                    Total Sales : &nbsp;PHP{" "}
                    {formatAmount(totalSummary.total_sales)}
                  </h5>
                </Col>
              </Row>

              {filter.payment_type === "cash" && (
                <Row>
                  <Table
                    tableHeaders={["SI #","AMOUNT"]}
                    headerSelector={["si_no","amount"]}
                    tableData={cashTableData}
                    showLoader={showLoader}
                  ></Table>
                </Row>
              )}
              {filter.payment_type === "credit" && (
                <>
                  <Row className="w-100 mt-2">
                    <Col
                      md={12}
                      lg={6}
                      className="d-flex justify-content-around"
                    >
                      <Button
                        className={`${
                          creditType === "card" ? "tab-btn-active" : ""
                        } tab-btn w-20`}
                        onClick={() => {
                          setCreditType("card");
                          setTotalSummary({
                            total_transaction: creditTableData["card"]
                              ? creditTableData["card"].length.toString()
                              : "0",
                            total_sales: creditTableData[`card_subtotal`],
                          });
                        }}
                      >
                        CARD
                      </Button>
                      <Button
                        className={`${
                          creditType === "foodpanda" ? "tab-btn-active" : ""
                        } tab-btn w-20`}
                        onClick={() => {
                          setCreditType("foodpanda");
                          setTotalSummary({
                            total_transaction: creditTableData["foodpanda"]
                              ? creditTableData["foodpanda"].length.toString()
                              : "0",
                            total_sales: creditTableData[`foodpanda_subtotal`],
                          });
                        }}
                      >
                        FOODPANDA
                      </Button>
                      <Button
                        className={`${
                          creditType === "grab" ? "tab-btn-active" : ""
                        } tab-btn w-20`}
                        onClick={() => {
                          setCreditType("grab");
                          setTotalSummary({
                            total_transaction: creditTableData["grab"]
                              ? creditTableData["grab"].length.toString()
                              : "0",
                            total_sales: creditTableData[`grab_subtotal`],
                          });
                        }}
                      >
                        GRAB
                      </Button>
                      <Button
                        className={`${
                          creditType === "gcash" ? "tab-btn-active" : ""
                        } tab-btn w-20`}
                        onClick={() => {
                          setCreditType("gcash");
                          setTotalSummary({
                            total_transaction: creditTableData["gcash"]
                              ? creditTableData["gcash"].length.toString()
                              : "0",
                            total_sales: creditTableData[`gcash_subtotal`],
                          });
                        }}
                      >
                        GCASH
                      </Button>
                      <Button
                        className={`${
                          creditType === "maya" ? "tab-btn-active" : ""
                        } tab-btn w-20`}
                        onClick={() => {
                          setCreditType("maya");
                          setTotalSummary({
                            total_transaction: creditTableData["maya"]
                              ? creditTableData["maya"].length.toString()
                              : "0",
                            total_sales: creditTableData[`maya_subtotal`],
                          });
                        }}
                      >
                        MAYA
                      </Button>
                      <Button
                        className={`${
                          creditType === "charge" ? "tab-btn-active" : ""
                        } tab-btn w-20`}
                        onClick={() => {
                          setCreditType("charge");
                          setTotalSummary({
                            total_transaction: creditTableData["charge"]
                              ? creditTableData["charge"].length.toString()
                              : "0",
                            total_sales:
                              creditTableData[`charge_subtotal`] ?? 0,
                          });
                        }}
                      >
                        CHARGE
                      </Button>
                    </Col>
                  </Row>
                  <Row className="mt-1">
                    <Table
                      tableHeaders={["APPROVAL #","AMOUNT" ]}
                      headerSelector={["reference_no","amount"]}
                      tableData={creditTableData[creditType]}
                      showLoader={showLoader}
                    ></Table>
                  </Row>
                </>
              )}
            </Row>
          </div>
          {/* </Tab>
          </Tabs> */}
        </Row>
      </div>

      {/* {
          allowPrint &&  */}
      <div className="" style={{ position: "absolute", left: "-9999999px" }}>
        <div ref={cashRef}>
          <div className="d-flex justify-content-center">
            <style>{getPageMargins()}</style>
            <div className="print-area single-width rounded p-4">
              <Row className="text-center print-text">
                {window.company_name}
              </Row>
              <Row className="text-center print-text">
                {window.company_address}
              </Row>
              <Row className="text-center print-text">
                {window.company_vat_reg_tin}
              </Row>
              <Row className="text-center print-text">{window.company_min}</Row>
              <Row className="text-center print-text">{window.company_sn}</Row>
              <Row className="text-center print-text">
                {window.company_ptu_no}
              </Row>
              <Row className="text-center print-text">
                {window.company_issued_date}
              </Row>
              <table className="table table-bordered">
                <tbody>
                  <tr>
                    <td colSpan={2} className="print-text">
                      Daily Payment Summary Report
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2} className="print-text">
                      <strong>CASH</strong>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2} className="print-text">
                      <strong>
                        PAYMENT REPORT CASH <br />
                        {moment(filter.date_from).format("MMMM DD, YYYY")}
                      </strong>
                    </td>
                  </tr>
                  <tr>
                    <td className="print-text">
                      <strong>Cash</strong>
                    </td>
                    <td className="print-text ">
                      <strong>SI #</strong>
                    </td>
                  </tr>
                  {cashTableData.map((row) => {
                    return (
                      <tr>
                        <td className="print-text ">
                          {numberWithCommas(row.amount)}
                        </td>
                        <td className="print-text ">{row.si_no}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div ref={creditRef}>
          <div className="d-flex justify-content-center">
            <style>{getPageMargins()}</style>
            <div className="print-area single-width rounded p-4">
              <Row className="text-center print-text">
                {window.company_name}
              </Row>
              <Row className="text-center print-text">
                {window.company_address}
              </Row>
              <Row className="text-center print-text">
                {window.company_vat_reg_tin}
              </Row>
              <Row className="text-center print-text">{window.company_min}</Row>
              <Row className="text-center print-text">{window.company_sn}</Row>
              <Row className="text-center print-text">
                {window.company_ptu_no}
              </Row>
              <Row className="text-center print-text">
                {window.company_issued_date}
              </Row>
              <table className="table table-bordered">
                <tbody>
                  <tr>
                    <td colSpan={2} className="print-text">
                      Daily Payment Summary Report
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2} className="print-text">
                      <strong>CREDIT</strong>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2} className="print-text">
                      <strong>
                        PAYMENT REPORT CREDIT <br />
                        {moment(filter.date_from).format("MMMM DD, YYYY")}
                      </strong>
                    </td>
                  </tr>
                  <tr>
                    <td className="print-text ">
                      <strong>Card</strong>
                    </td>
                    <td className="print-text ">
                      <strong>Approval #</strong>
                    </td>
                  </tr>
                  {creditTableData.card?.map((row) => {
                    return (
                      <tr>
                        <td className="print-text ">
                          {numberWithCommas(row.amount)}
                        </td>
                        <td className="print-text ">
                          {row.reference_no ?? "---"}
                        </td>
                      </tr>
                    );
                  })}
                  <tr></tr>
                  <tr>
                    <td className="print-text ">
                      <strong>Grab</strong>
                    </td>
                    <td className="print-text">
                      <strong>Approval #</strong>
                    </td>
                  </tr>
                  {creditTableData.grab?.map((row) => {
                    return (
                      <tr>
                        <td className="print-text">
                          {numberWithCommas(row.amount)}
                        </td>
                        <td className="print-text">
                          {row.reference_no ?? "---"}
                        </td>
                      </tr>
                    );
                  })}
                  <tr></tr>
                  <tr>
                    <td className="print-text ">
                      <strong>Foodpanda</strong>
                    </td>
                    <td className="print-text">
                      <strong>Approval #</strong>
                    </td>
                  </tr>
                  {creditTableData.foodpanda?.map((row) => {
                    return (
                      <tr>
                        <td className="print-text">
                          {numberWithCommas(row.amount)}
                        </td>
                        <td className="print-text">
                          {row.reference_no ?? "---"}
                        </td>
                      </tr>
                    );
                  })}
                  <tr></tr>
                  <tr>
                    <td className="print-text ">
                      <strong>Maya</strong>
                    </td>
                    <td className="print-text ">
                      <strong>Approval #</strong>
                    </td>
                  </tr>
                  {creditTableData.maya?.map((row) => {
                    return (
                      <tr>
                        <td className="print-text ">
                          {numberWithCommas(row.amount)}
                        </td>
                        <td className="print-text">
                          {row.reference_no ?? "---"}
                        </td>
                      </tr>
                    );
                  })}
                  <tr></tr>
                  <tr>
                    <td className="print-text ">
                      <strong>Gcash</strong>
                    </td>
                    <td className="print-text ">
                      <strong>Approval #</strong>
                    </td>
                  </tr>
                  {creditTableData.gcash?.map((row) => {
                    return (
                      <tr>
                        <td className="print-text ">
                          {numberWithCommas(row.amount)}
                        </td>
                        <td className="print-text ">
                          {row.reference_no ?? "---"}
                        </td>
                      </tr>
                    );
                  })}
                  <tr></tr>
                  <tr>
                    <td className="print-text ">
                      <strong>Charge</strong>
                    </td>
                    <td className="print-text ">
                      <strong>Approval #</strong>
                    </td>
                  </tr>
                  {creditTableData.charge?.map((row) => {
                    return (
                      <tr>
                        <td className="print-text ">
                          {numberWithCommas(row.amount)}
                        </td>
                        <td className="print-text ">
                          {row.reference_no ?? "---"}
                        </td>
                      </tr>
                    );
                  })}
                  <tr></tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {/* } */}
    </div>
  );
}
